import React from "react";
import CollapsableWrapper from "../CollapsableWrapper/CollapsableWrapper";
import BasicUserInformation from "../BasicUserInformation/BasicUserInformation";
import ReviserData from "../ReviserData/ReviserData";
import Row from "../WrapperComponents/Row";
import ButtonComponent from "../../UI/ButtonComponent/ButtonComponent";
import AddressDataResidency from "../AddressDataResidency/AddressDataResidency";
import ColDynamic from "../WrapperComponents/ColDynamic";
import "./EntryForm4.css";
import DatepickerComponent from "../../UI/DatePicker/DatepickerComponent";
import { Spinner } from "react-bootstrap";

const EntryForm4 = (props) => {

  const popuniZagradu = (clan) =>{
    if(clan.ime && clan.prezime){
      return `(${clan.ime} ${clan.prezime})`;
    }else if(clan.nazDrustva){
      return `(${clan.nazDrustva})`;
    }
  return "(Novi unos)";
}

  const { reviserRegistration } = props.parentState.newFormData;
  const mappedReviserData = reviserRegistration.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`reviser-registration-${index}-collapse`}
        clickText={`Podaci o revizorskom društvu ili samostalnom revizoru kod kojeg je revizorski vježbenik zaposlen ili je na stručnom osposobljavanju bez zasnivanja radnog odnosa 
        ${popuniZagradu(element)}`}
      >
        <ReviserData required id={element.id} {...props} />
        <Row>
          <ColDynamic className="col-lg-4 dp-style-lg4">
            <DatepickerComponent
              required={!element.datPocSo}
              errorBorderColor={
                props.parentState.error &&
                !element.datPocRo &&
                !element.datPocSo &&
                "red"
              }
              handleDayClick={props.handleDayClick}
              controlLabel={"Datum početka radnog odnosa"}
              value={element.datPocRo}
              index={{
                group: "reviserRegistration",
                prop: "datPocRo",
                id: element.id,
              }}
              width={"100%"}
            />
          </ColDynamic>

          <ColDynamic className="col-lg-4 dp-style-lg4">
            <DatepickerComponent
              required={!element.datPocRo}
              errorBorderColor={
                props.parentState.error &&
                !element.datPocSo &&
                !element.datPocRo &&
                "red"
              }
              handleDayClick={props.handleDayClick}
              controlLabel={"Datum početka stručnog osposobljavanja"}
              value={element.datPocSo}
              index={{
                group: "reviserRegistration",
                prop: "datPocSo",
                id: element.id,
              }}
              width={"100%"}
            />
          </ColDynamic>
          <div style={{ width: "80.75px" }}></div>
        </Row>
        <br></br>
        <Row>
          <ColDynamic className="col-lg-4">
            {reviserRegistration.length - 1 === index ? 
              <ButtonComponent
                id={element.id}
                onClick={(e) =>
                  props.multiplyComponent(e, { formGroup: "reviserRegistration" })
                }
              >
                Dodaj novi
              </ButtonComponent>
            :
              null
            }
          </ColDynamic>
          <ColDynamic className="col-lg-4">
            {reviserRegistration.length > 1 && (
              <ButtonComponent
                variant="danger"
                id={element.id}
                onClick={(e) =>
                  props.removeComponentHandler(e, {
                    formGroup: "reviserRegistration",
                  })
                }
              >
                Ukloni
              </ButtonComponent>
            )}
          </ColDynamic>
        </Row>
      </CollapsableWrapper>
    );
  });

  const disableCounty = props.parentState.newFormData.address.sifDrzave
    ? false
    : true;
  const disableCity = props.parentState.newFormData.address.sifZupanije
    ? false
    : true;
  const disableDistrict = props.parentState.newFormData.address.sifGrdOpc
    ? false
    : true;

  return (
    <>
      <CollapsableWrapper clickText="Osnovni podaci">
        <BasicUserInformation
          disabled={
            props.parentState.newFormData.oznDokumenta.oznDokumenta !== null &&
            props.parentState.update &&
            props.parentState.newFormData.userData.oznAkt == 1
          }
          required
          {...props}
        />
      </CollapsableWrapper>
      <CollapsableWrapper clickText="Podaci o adresi i registraciji">
        <AddressDataResidency
          required
          disableDistrict={disableDistrict}
          disableCity={disableCity}
          disableCounty={disableCounty}
          {...props}
        />
      </CollapsableWrapper>
      {mappedReviserData}
      <br></br>
      <div className="invert">
        {props.parentState.loader ? (
          <ButtonComponent disabled>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />{" "}
            Spremanje...
          </ButtonComponent>
        ) : (
          <ButtonComponent onClick={props.submitHandler}>
            {props.parentState.update ? "Spremi promjene" : "Unos u registar"}
          </ButtonComponent>
        )}
      </div>
    </>
  );
};

export default EntryForm4;
